import { createRoot } from "react-dom/client";
import "./index.css";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import "tw-elements-react/dist/css/tw-elements-react.min.css";
import LoginPage from "./modules/Auth/LoginPage.tsx";
import ForgotPasswordPage from "./modules/Auth/ForgotPasswordPage.tsx";
import ChangePasswordPage from "./modules/Auth/ChangePasswordPage.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import HeavyNotification from "./components/HeavyNotification.tsx";
import "remixicon/fonts/remixicon.css";
import NiceModal from "@ebay/nice-modal-react";
import DashboardLayout from "./components/layouts/DashboardLayout.tsx";
import { ActivateCollaboratorPage } from "./modules/Users/Collaborators/pages/ActivateCollaboratorPage.tsx";
import RoutePlaceholder from "./modules/RoutePlaceholder.tsx";
import DocumentiUtiliPage from "./modules/DocumentiUtili/DocumentiUtiliPage.tsx";
import MaterialeDidatticoPage from "./modules/Didattica/MaterialeDidattico/MaterialeDidatticoPage.tsx";

// Pagine Corsi - nuova struttura ordinata
import {
  FadCorsoPage,
  AulaCorsoPage,
  MistoCorsoPage,
  WebinarCorsoPage,
} from "./modules/Didattica/Corsi/pages";

// Stub per demo (lista corsi con dati mock)
import CorsiListStub from "./modules/Didattica/Corsi/_stub/CorsiListStub.tsx";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/change-password",
    element: <ChangePasswordPage />,
  },
  {
    path: "/activate",
    element: <ActivateCollaboratorPage />,
  },
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      // ============================================
      // Route Form Corsi (usate dal pageRegistry)
      // Pattern: /form/corsi/{tipo}
      // ============================================
      {
        path: "form/corsi/fad",
        element: <FadCorsoPage />,
      },
      {
        path: "form/corsi/aula",
        element: <AulaCorsoPage />,
      },
      {
        path: "form/corsi/misto",
        element: <MistoCorsoPage />,
      },
      {
        path: "form/corsi/webinar",
        element: <WebinarCorsoPage />,
      },

      // ============================================
      // Route Demo/Stub (pagine con dati mock)
      // Da rimuovere quando il backend è pronto
      // ============================================
      {
        path: "demo/didattica/corsi",
        element: <CorsiListStub />,
      },
      {
        path: "demo/didattica/materiale-didattico",
        element: <MaterialeDidatticoPage />,
      },
      {
        path: "demo/documenti-utili",
        element: <DocumentiUtiliPage />,
      },

      // ============================================
      // Catch-all: gestito da RoutePlaceholder
      // Include get_page/* per pagine dinamiche
      // ============================================
      {
        path: "*",
        element: <RoutePlaceholder />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
]);

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <NiceModal.Provider>
      <RouterProvider router={router} />
      <Toaster position="top-right" />
      <HeavyNotification />
    </NiceModal.Provider>
  </QueryClientProvider>
);
